export enum DialogIcon {
  None = 'NONE',
  InfoRed = 'INFO_RED',
  AlertRed = 'ALERT_RED',
  InfoGreenTick = 'INFO_GREEN_TICK',
  CheckRedAlert = 'CHECK_RED_ALERT',
  IdCard = 'ID_CARD',
}
